import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const navCls = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-2 rounded-md text-sm font-medium ${isActive ? 'bg-brand-500 text-white' : 'text-slate-700 hover:bg-slate-200'}`;

export default function Layout() {
  const { user, role, signOut } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-full">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
          <Link to="/" className="text-lg font-semibold text-brand-700">CRM Clínica</Link>
          <nav className="flex gap-2">
            <NavLink to="/dashboard"    className={navCls}>Dashboard</NavLink>
            <NavLink to="/atendimentos" className={navCls}>Atendimentos</NavLink>
            <NavLink to="/pipeline"     className={navCls}>Pipeline</NavLink>
            <NavLink to="/pacientes"    className={navCls}>Pacientes</NavLink>
            <NavLink to="/campanhas"    className={navCls}>Campanhas</NavLink>
            {role === 'admin' && (
              <>
                <NavLink to="/admin/funcionarias"   className={navCls}>Funcionárias</NavLink>
                <NavLink to="/admin/vissmed-import" className={navCls}>Importar Vissmed</NavLink>
                <NavLink to="/admin/settings"       className={navCls}>Admin</NavLink>
              </>
            )}
          </nav>
          <div className="text-sm text-slate-600 flex items-center gap-3">
            <span>{user?.email} <span className="text-xs text-slate-400">({role ?? 'no role'})</span></span>
            <button
              onClick={async () => { await signOut(); nav('/login'); }}
              className="text-sm px-3 py-1.5 rounded-md border border-slate-300 hover:bg-slate-100"
            >Sair</button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
